import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";

/**
 * Codifica del "customLink" (azienda/licenza/reparto/utente…) usata nei link
 * di compilazione e login: Base64(UTF-8(JSON)). Stesso output delle copie
 * inline `CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(JSON.stringify(x)))`.
 */
export function encodeCustomLink(obj: any): string {
  return Base64.stringify(Utf8.parse(JSON.stringify(obj)));
}

/** Inverso di `encodeCustomLink`. Lancia se il token non è Base64/JSON valido (come le copie inline). */
export function decodeCustomLink(token: string): any {
  return JSON.parse(Utf8.stringify(Base64.parse(token)));
}
